import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import {
  mobileVerification,
  registerUser,
  sendOtpToEmail,
  sendOtpToMobile,
  verifyEmailOtp,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { APP_CONST, AFF_KEY_LS } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-input-2";
import { FiEye, FiEyeOff } from "react-icons/fi";
import Animate1 from "../../../assets/images/icons/login-reg/football.webp";
import Animate2 from "../../../assets/images/icons/login-reg/basketball.webp";
import Animate3 from "../../../assets/images/icons/login-reg/tennis.webp";

const RegisterModal = ({
  show,
  handleClose,
  handleModalShow,
  agentCode: agentCodeProp,
}) => {
  const validationMessages = [
    {
      text: "At least 8 characters with 1 digit, 1 lowercase, and 1 uppercase.",
      key: 1,
    },
    // { text: "at least 8 symbols", key: 1 },
    // { text: "at least 1 digit (0-9)", key: 2 },
    // { text: "at least 1 lowercase characters (a-z)", key: 3 },
    // { text: "at least 1 uppercase characters (A-Z)", key: 4 },
  ];

  const dispatch = useDispatch();

  const [showPasswordValidtions, setShowPasswordValidations] = useState(false);
  const [validationIndex, setValidationIndex] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  const [showPassword, setShowPassword] = useState(false);
  const [agentCode, setAgentCode] = useState(agentCodeProp);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtpValue] = useState("");
  const affId = localStorage.getItem(AFF_KEY_LS);
  const appDetails = useSelector((state) => state.app?.appDetails);
  const [email, setEmail] = useState({ email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;

  const [registerConfig, setRegisterConfig] = useState({
    isOtpEnabled: useSelector((state) => state?.app?.appDetails?.OTP) === 0,
    mobileDetails: {},
    isSendingOtp: false,
    isVerifyingOtp: false,
    isOtpSent: false,
    isOtpVerified: false,
    showPassword: false,
    showConfirmPassword: false,
  });

  const sendEmailOTPSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!Boolean(email.email) || email.email == "") {
      return;
    }
    handleRegisterConfigChange({ isSendingOtp: true });
    const response = await sendOtpToEmail(email);
    handleRegisterConfigChange({ isSendingOtp: false });
    if (response) {
      handleRegisterConfigChange({ isOtpSent: true });
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        response?.data?.message || "OTP sent",
      );
    }
    setIsLoading(false);
  };

  // const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState("");

  const verifyEmailOtpSubmit = async (e) => {
    e.preventDefault();
    if (!otp) {
      return;
    }
    setIsVerifying(true);
    const response = await verifyEmailOtp({
      email: email?.email,
      otp: otp,
    });
    if (response) {
      handleRegisterConfigChange({ isOtpVerified: true });
      setIsEmailVerified(true);
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        response?.data?.message || "OTP Verified",
      );
    }
    setIsVerifying(false);
  };

  const checkForPasswordValidations = (e) => {
    const password = e.target.value;
    let fulfilledindex = [];
    if (password.length >= 8) {
      fulfilledindex.push(1);
    }
    if (/\d/.test(password)) {
      fulfilledindex.push(2);
    }
    const smallAlp = new RegExp("(?=.*[a-z])");
    if (smallAlp.test(password)) {
      fulfilledindex.push(3);
    }
    const capAlp = new RegExp("(?=.*[A-Z])");
    if (capAlp.test(password)) {
      fulfilledindex.push(4);
    }
    setValidationIndex(fulfilledindex);
  };

  const validateData = (data = null) => {
    const dataToValidate = data ? data : formData;
    const { name, username, password, confirmPassword } = dataToValidate;
    const newErrors = {};
    if (!name || name === "") {
      newErrors.name = "Name cannot be empty";
    }
    // if (!username || username === "") {
    //   newErrors.userName = "User name cannot be empty";
    // }
    // if (username && (username.length < 4 || username.length > 15)) {
    //   newErrors.userName = "Username must be 4 to 15 characters.";
    // }
    // if (!/^[A-Za-z0-9 ]+$/.test(username)) {
    //   newErrors.userName = "Special characters are not allowed in username.";
    // }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    if (password && (password.length < 8 || password.length > 20)) {
      newErrors.password = "Password must be 8 to 20 characters.";
    }
    // if (!confirmPassword || confirmPassword === "") {
    //   // newErrors.confirmPassword = "Confirm password cannot be empty";
    // } else if (password !== confirmPassword) {
    //   // newErrors.confirmPassword = "Password and Confirm password must be same";
    // }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorsData = validateData();

    if (Object.keys(errorsData).length > 0) {
      return;
    }

    let dataToSend = { ...formData };
    if (isEmailOtpRequired) {
      // if (!Boolean(mobileNumber)) {
      //   Toaster(APP_CONST.TOAST_TYPE.ERROR, "Mobile is required");
      // }
      dataToSend = {
        ...dataToSend,
        email: email?.email,
      };
    } else {
      dataToSend.mobile = registerConfig?.mobileDetails?.mobile;
      dataToSend.country_code = registerConfig?.mobileDetails?.country_code;
    }

    // dataToSend.name = formData?.username;

    delete dataToSend.confirmPassword;
    if (agentCode) {
      dataToSend.agent_code = agentCode;
    }

    // Send tracking id , if exist
    if (affId) {
      dataToSend.affId = affId;
    }

    // Gemerate random username here

    dataToSend["username"] = "YILDIZUSER";
    dispatch(
      registerUser({
        ...dataToSend,
      }),
    );
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
    validateData(tempFormData);
  };

  const handleRegisterConfigChange = (config) => {
    setRegisterConfig((p) => ({ ...p, ...config }));
  };

  const sendOtp = () => {
    handleRegisterConfigChange({
      isSendingOtp: true,
    });
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    payload.mobile = phoneNumber.nationalNumber;
    payload.country_code = phoneNumber.countryCallingCode;

    dispatch(sendOtpToMobile(payload))
      .then((res) => {
        handleRegisterConfigChange({
          mobileDetails: payload,
          isOtpSent: true,
          isSendingOtp: false,
        });
        if (res?.data?.error === false) {
          Toaster(
            APP_CONST.TOAST_TYPE.SUCCESS,
            res?.data?.message || "OTP sent",
          );
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
        handleRegisterConfigChange({
          isSendingOtp: false,
        });
      });
  };

  const verifyOtp = () => {
    handleRegisterConfigChange({
      isVerifying: true,
    });
    dispatch(mobileVerification({ ...registerConfig.mobileDetails, otp }))
      .then((res) => {
        handleRegisterConfigChange({
          isVerifying: false,
          isOtpVerified: true,
          isOtpSent: true,
        });
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP verified");
      })
      .catch((err) => {
        handleRegisterConfigChange({
          isVerifying: false,
        });
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  };

  const getIfDisable = () => {
    if (isEmailOtpRequired && !isEmailVerified) {
      return true;
    }
    if (registerConfig?.isOtpEnabled && !registerConfig?.isOtpVerified) {
      return true;
    }

    if (!registerConfig?.isOtpSent) {
      return true;
    }
    return false;
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas lgn-reg-modal register"}
      centered
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
      ></Modal.Header>

      <Modal.Body>
        <div className="animation-register d-sm-none">
          <img src={Animate1} alt="Animate 1" className="img1" />
          <img src={Animate2} alt="Animate 2" className="img2" />
          <img src={Animate3} alt="Animate 3" className="img3" />
        </div>

        <div className="inner-wrapper">
          <div className="right-content">
            <h2 className="title">Registration</h2>

            <div className="form-steps">
              <Form>
                {/* <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={"text"}
                    name="name"
                    placeholder="Name*"
                    onChange={handleChange}
                    isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.name}
                  </Form.Control.Feedback>
                </Form.Group> */}
                <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Full name*"
                    onChange={handleChange}
                    isInvalid={!!errors.name}
                    // onBlur={checkUserName}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors?.name}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password*"
                    autoComplete="new-password"
                    onChange={(e) => {
                      handleChange(e);
                      checkForPasswordValidations(e);
                    }}
                    isInvalid={!!errors.password}
                    onFocus={() => {
                      setShowPasswordValidations(true);
                    }}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword((p) => !p)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors?.password}
                  </Form.Control.Feedback>
                </Form.Group>
                {/* <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password*"
                    onChange={handleChange}
                    isInvalid={!!errors.confirmPassword}
                    onFocus={() => {
                      setShowPasswordValidations(true);
                    }}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowConfirmPassword((p) => !p)}
                  >
                    {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors?.confirmPassword}
                  </Form.Control.Feedback>
                </Form.Group> */}
                {showPasswordValidtions && (
                  <div className="password-note mb-2 mb-sm-3">
                    <ul>
                      {validationMessages.map((item, index) => {
                        const result = validationIndex.find(
                          (i) => i === item.key,
                        );
                        return (
                          <li
                            className={result ? "pwd-validation-message" : ""}
                          >
                            {item?.text}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
                <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={"text"}
                    name="agent_code"
                    placeholder="Please enter Referral Code"
                    value={agentCode}
                    onChange={(e) => setAgentCode(e.target.value)}
                  />
                </Form.Group>

                {!isEmailOtpRequired && (
                  <>
                    {" "}
                    <div className="get-otp mb-2">
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicPassword"
                      >
                        <PhoneInput
                          country={"tm"}
                          countryCodeEditable={false}
                          inputProps={{
                            name: "phone",
                            required: true,
                          }}
                          inputStyle={{ width: "100%" }}
                          onChange={(phone) => {
                            setMobileNumber(phone);
                          }}
                        />
                      </Form.Group>
                      <Button
                        variant="primary"
                        onClick={sendOtp}
                        className="registerButton"
                        disabled={registerConfig.isSendingOtp}
                      >
                        {registerConfig.isSendingOtp ? "Loading.." : "Submit"}
                      </Button>
                      {registerConfig?.isOtpEnabled && (
                        <p className="otpnote">
                          <span>Note:</span> user can request a new otp after
                          every five minutes.
                        </p>
                      )}
                    </div>
                    {registerConfig?.isOtpEnabled && (
                      <div className="verify-otp">
                        <Form.Group
                          className="mb-1 position-relative"
                          controlId="formBasicPassword"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Enter OTP*"
                            className="verifyOtp"
                            onChange={(e) => setOtpValue(e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="primary"
                          onClick={verifyOtp}
                          disabled={
                            registerConfig.isVerifyingOtp ||
                            !registerConfig.isOtpSent ||
                            !otp
                          }
                        >
                          {!registerConfig.isOtpVerified
                            ? !registerConfig.isVerifyingOtp
                              ? "Verify OTP"
                              : "Submitting"
                            : "Verified"}
                        </Button>
                      </div>
                    )}
                  </>
                )}

                {isEmailOtpRequired && (
                  <>
                    {/* <div className="get-otp mb-2">
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicPassword"
                      >
                        <PhoneInput
                          country={"tm"}
                          countryCodeEditable={false}
                          inputProps={{
                            name: "phone",
                            required: true,
                          }}
                          inputStyle={{ width: "100%" }}
                          onChange={(phone) => {
                            setMobileNumber(phone);
                          }}
                        />
                      </Form.Group>
                    </div> */}

                    <div className="get-otp">
                      <Form.Group
                        className="mb-3 position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type="email"
                          placeholder="Enter email*"
                          value={email.email}
                          onChange={(e) => setEmail({ email: e.target.value })}
                        />
                      </Form.Group>
                      <Button
                        variant="primary"
                        // type="submit"
                        onClick={sendEmailOTPSubmit}
                        className="loginbtn"
                        disabled={isLoading || !Boolean(email.email)}
                      >
                        {isLoading ? "Loading.." : "Send OTP"}
                      </Button>
                    </div>

                    <div className="verify-otp mb-2">
                      <Form.Group
                        className="mb-1 position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type="text"
                          value={otp}
                          placeholder="Enter OTP*"
                          onChange={(e) => setOtpValue(e.target.value)}
                        />
                      </Form.Group>
                      <Button
                        variant="primary"
                        disabled={isVerifying}
                        onClick={verifyEmailOtpSubmit}
                      >
                        {!isVerifying ? "Verify" : "Submitting"}
                      </Button>
                    </div>
                  </>
                )}

                <Button
                  variant="primary"
                  type="submit"
                  className="register mb-2"
                  onClick={handleSubmit}
                  disabled={getIfDisable()}
                >
                  Register
                </Button>
              </Form>
            </div>
          </div>

          <div className="account-signin-signup register">
            Already have an account?&nbsp;
            <a
              href="#"
              onClick={() => {
                handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                handleClose(APP_CONST.AUTH_MODAL.REGISTER);
              }}
            >
              <p>Log In</p>
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RegisterModal;
